var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcMargarinaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.26,30H49.74a1.23,1.23,0,0,0,.87-.36,1.21,1.21,0,0,0,.37-.87v-16a1.25,1.25,0,0,0-1.24-1.24H37.4v1.85a1.85,1.85,0,0,1-3.7,0v4.94a4.32,4.32,0,0,1-8.64,0V11.49H10.26A1.24,1.24,0,0,0,9,12.73v16a1.21,1.21,0,0,0,.37.87,1.23,1.23,0,0,0,.87.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.26,48.51H49.74a1.27,1.27,0,0,0,.88-.36,1.25,1.25,0,0,0,.36-.88V33.7a1.23,1.23,0,0,0-.36-.87,1.27,1.27,0,0,0-.88-.36H26.3v5.85a4.15,4.15,0,0,1-4.32,4,4.15,4.15,0,0,1-4.32-4V34a1.7,1.7,0,0,1-1.85,1.5A1.7,1.7,0,0,1,14,34V32.47h-3.7A1.24,1.24,0,0,0,9,33.7V47.27a1.25,1.25,0,0,0,.36.88A1.27,1.27,0,0,0,10.26,48.51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcMargarinaGreen);
export default __webpack_public_path__ + "static/media/DC__Margarina_green.a80d8b08a24ff0d49c6fb678b6ed3c2b.svg";
export { ForwardRef as ReactComponent };